import React from 'react';

import { getCustomId } from 'app/libs/core/Unique';

import store from 'app/store';

import {
  PlaceIconName,
  PlaceIconNameActive,
} from 'app/constants/place.constant';

import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

import { isWrongCoord } from 'app/components/Utility/utility';

import { Icon, ActiveIcon } from 'app/constants/TourPoints';
import { Point } from 'app/libs/map/drive/Point';

export const getPointIcon = (
  { id, type, iconType, place_type = null },
  isSelected
) => {
  if (place_type) {
    const style = {
      maxWidth: 20,
      maxHeight: 25,
      width: 18,
      minWidth: 18,
      minHeight: 25,
    };

    return (
      <img
        draggable={false}
        src={
          isSelected
            ? PlaceIconNameActive[place_type]
            : PlaceIconName[place_type]
        }
        alt={`icon point type ${place_type}`}
        key={id}
        style={style}
      />
    );
  }
  const style =
    iconType || type === Point.Type.START || type === Point.Type.END
      ? { maxWidth: 20, maxHeight: 25, width: 18, minWidth: 18, minHeight: 25 }
      : { maxWidth: 18, maxHeight: 20, width: 18, minWidth: 18, minHeight: 20 };
  const isIconType = iconType || type;
  return (
    <img
      draggable={false}
      src={isSelected ? ActiveIcon[isIconType] : Icon[isIconType]}
      alt={`icon point type ${type}`}
      key={id}
      style={style}
    />
  );
};

export const freePoints = (points) =>
  points.map((point) => {
    const customId = getCustomId();
    point.id = customId;
    point.unique_id = customId;
    point.description = '';
    point.images = [];
    point.imgids = '';
    return point;
  });

export const removeIdFromParts = (parts, user) =>
  parts.map((part) => {
    delete part.id;
    delete part.parent_tour_id;
    part.description = '';
    part.images = [];
    part.imgids = '';
    part.user = user;
    part.owner = user.id;
    return part;
  });

export const userInfoForTour = (fullUser) => {
  const { id = '', name = '', sex = '', avatar = '' } = fullUser;
  const userData = {
    id: id.toString(),
    name,
    sex,
    avatar,
  };
  return userData;
};

export const getTourId = ({ location = {} }) => {
  const str = location.pathname
    .replace(/[^\w\s]/gi, '')
    .replace(' ', '_')
    .split('_')
    .splice(-1)
    .pop();
  return location.pathname && parseInt(str) ? parseInt(str) : 0;
};

export const updateIndex = () => {
  const { points } = store.getState().tourFullData.activeMultiPart;
  if (points && points[0]) {
    const { id } = points[0];
    const { unique_id: uniqueId } = points[0];
    publish(way.DRIVE_LIST_POINT_UPDATE_INDEX, {
      customId: id,
      index: 0,
      isLoading: true,
      unique_id: uniqueId,
    });
  }
};

export const isWrongRoutesExists = () => {
  const { points } = store.getState().tourFullData.activeMultiPart;
  const { isEditMode } = store.getState().tourFullData;

  if (!isEditMode) {
    return false;
  }
  if (points && points.length > 0 && typeof points.filter === 'function') {
    const wrongRoads = points.filter((point) => isWrongCoord(point));
    if (wrongRoads.length > 0) {
      return true;
    }
  }
  return false;
};

/*eslint-disable*/
export const isThereAnyWrongRouteInAllTourPages = () => {
  const { multiDay, parts = [] } = store.getState().tourFullData.data;
  let wrongRoads = [];
  if (multiDay) {
    parts ||
      [].forEach((part = []) => {
        if (typeof part.points === 'string') {
          part.points = JSON.parse(part.points);
        }
        const roads = part.points.filter((point) => isWrongCoord(point));
        wrongRoads = wrongRoads.concat(roads);
      });
    if (wrongRoads.length > 0) {
      return true;
    }
  }
  return false;
};
/* eslint-enable */

export const isShapingDataExists = () => {
  const { pointsData } = store.getState().tourFullData.activeMultiPart;
  return (
    pointsData &&
    typeof pointsData === 'object' &&
    Object.keys(pointsData).length > 0
  );
};
